import moment from 'moment';

export default function formatDate(date, format = 'DD.MM.YYYY') {
  return date ? moment(date).format(format) : null;
}
